import templateUrl from 'emun.salesrep/credithold-orders.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import orderConfig from 'emun.order/order.config';

class CreditHoldOrdersController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);

    $ctrl.orderConfig = orderConfig;
    var context = $ctrl.context || 'rep';
    var repFilter = "";
    if (context != 'executive') {
      var filterType = "SalesRepID";
      if (context == 'manager') {
        filterType = 'ManagerId';
      }
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }

    //var filter = "SalesRepID";
    //if (context == 'manager') { filter = "ManagerId";}

    $ctrl.creditholdOrders = new AutoQuery({
      url: 'QueryCartsJoin.json?onlyCreditHold=1' + repFilter,
      orderBy: '-OrderedOn',
      autoLoad: true,
      pageSize: 10,
      scrollTop: false
    })
  }
}

let CreditHoldOrders = {
  bindings: {
    repId: '@',
    context: '@',
    rep: '<'
  },
  controller: CreditHoldOrdersController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default CreditHoldOrders